var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState } from "react";
import useFormApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-form-api";
import { Button } from "../Button/Button";
import { useSelector } from "react-redux";
import { CART_EVENT } from "../../Cart/cart.constants";
import { useEmitter, useScopedEventName } from "../../../helpers/customEvents";
import get from "lodash/get";
import styled from "styled-components";
import { CART_TITLE, CART_QUANTITY, CART_PRICE, CART_TOTAL, CART_MODIFY, CART_REMOVE, CART_TABLE_ROW, CART_TABLE_ROW_ADMIN, CART_TABLE_ROW_UI, CART_ITEM, CART_TABLE_ROW_DESCRIPTION, CART_EXTRA_ITEM, CURSOR_POINTER } from "../../../classConstants";
import { CenterAlignedCell, LeftAlignedCell, RightAlignedCell } from "../../Table";
import { getClassName, useMediaQuery } from "../../../helpers";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import { SvgIcon } from "../../../icons";
import { isAdminIntegration } from "../../../store/statePresenter";
export var CartTableRow = function (props) {
    var _a, _b;
    var t = useTranslation().t;
    var _c = useState(false), modify = _c[0], setModify = _c[1];
    var scopedCartEventName = useScopedEventName(CART_EVENT);
    var emitCartItems = useEmitter(scopedCartEventName);
    var cartItems = useSelector(function (state) { return get(state, "cartReducer.cart_items", []); });
    var titleRef = useRef(null);
    var className = useSelector(function (state) { return isAdminIntegration(state); }) ? CART_TABLE_ROW_ADMIN : CART_TABLE_ROW_UI;
    var titleWidthRef = useRef("");
    var isSmallScreen = useMediaQuery("(max-width: 600px)");
    var renderModifyForm = function () {
        if (!modify)
            return null;
        return (React.createElement("tr", { className: CART_TABLE_ROW_DESCRIPTION },
            React.createElement("td", { colSpan: 3 }, props.children),
            React.createElement("td", { colSpan: 1 }),
            React.createElement("td", { colSpan: 2 })));
    };
    var actionCreator = function (cb) { return function (e) {
        e.preventDefault();
        e.stopPropagation();
        cb();
    }; };
    var toggleModify = actionCreator(function () {
        if (!props.children || !props.parentNode)
            return;
        if (!modify && titleRef.current) {
            var width = titleRef.current.getBoundingClientRect().width;
            titleWidthRef.current = width ? width + "px" : "";
        }
        ;
        setModify(!modify);
    });
    var renderModifyButton = function () {
        if (!props.parentNode)
            return null;
        return (React.createElement(IconOnCart, { context: "cart", variant: "clear", icon: React.createElement(SvgIcon, { type: "edit" }), onClick: toggleModify }));
    };
    var renderRemoveButton = function () {
        if (props.hideRemoveButton)
            return null;
        var removeFunc = props.parentNode ? removeParentNode : removeCartItem;
        return React.createElement(IconOnCart, { context: "cart", variant: "clear", icon: React.createElement(SvgIcon, { type: "close" }), onClick: actionCreator(function () { return removeFunc(); }) });
    };
    var removeParentNode = function () {
        emitCartItems({ cartItems: cartItems.filter(function (x, i) { return i !== props.index; }) });
    };
    var removeCartItem = function () {
        props.onRemove(props.name);
    };
    var titleProps = {
        ref: titleRef,
        onClick: toggleModify,
        style: {
            width: titleWidthRef.current || ""
        },
        className: getClassName(CART_TITLE, (_a = {}, _a[CURSOR_POINTER] = props.parentNode, _a))
    };
    return (React.createElement(Tbody, { as: props.as, countOfSlots: isSmallScreen ? 3 : 6, className: getClassName(props.className, CART_TABLE_ROW, className) },
        React.createElement("tr", { className: getClassName(CART_ITEM, (_b = {}, _b[CART_EXTRA_ITEM] = !props.parentNode, _b)) },
            React.createElement(LeftAlignedCell, __assign({}, titleProps),
                " ",
                parse(props.title || ""),
                " "),
            React.createElement(RightAlignedCell, { onClick: toggleModify, className: getClassName(CART_QUANTITY, CURSOR_POINTER) },
                " ",
                props.quantity,
                " "),
            React.createElement(RightAlignedCell, { onClick: toggleModify, className: getClassName(CART_PRICE, CURSOR_POINTER) },
                " ",
                props.price,
                " "),
            React.createElement(RightAlignedCell, { onClick: toggleModify, className: getClassName(CART_TOTAL, CURSOR_POINTER) },
                " ",
                props.total,
                " "),
            React.createElement(CenterAlignedCell, { className: CART_MODIFY }, renderModifyButton()),
            React.createElement(CenterAlignedCell, { className: CART_REMOVE }, renderRemoveButton())),
        renderModifyForm()));
};
export var ReactiveCartTableRow = function (_a) {
    var fields = _a.fields, props = __rest(_a, ["fields"]);
    var formOptions = useFormApi();
    var onRemove = function (name) {
        if (name) {
            formOptions.change(name, 0);
        }
    };
    return React.createElement(CartTableRow, __assign({}, props, { onRemove: onRemove, children: formOptions.renderForm(fields, formOptions) }));
};
export var Tbody = styled.tbody.attrs(function (props) { return ({ countOfSlots: get(props, "countOfSlots") }); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    --ws-table-ends-padding: var(--ws-cart-ends-padding);\n    .", ", .", " {\n        width: 2em;\n    }\n\n    .", ", .", " {\n        white-space: nowrap;\n    }\n\n    \n    tbody&.", " {\n        .", " td {\n            border-top-width: 0;\n            border-bottom-width: 0;\n            padding-top: var(--ws-cart-table-row-padding-v);\n            padding-bottom: 0;\n        }\n\n        .", " td {\n            border-top-width: 0;\n            border-bottom-width: 0;\n        }\n\n        &:first-of-type .", ":first-of-type td {\n            border-top-width: 1px;\n        }\n\n        &:last-of-type .", ":last-of-type td { \n            padding-bottom: var(--ws-cart-table-row-padding-v);\n            border-bottom-width: 1px;\n        }\n    }\n\n    ", "\n"], ["\n    --ws-table-ends-padding: var(--ws-cart-ends-padding);\n    .", ", .", " {\n        width: 2em;\n    }\n\n    .", ", .", " {\n        white-space: nowrap;\n    }\n\n    \n    tbody&.", " {\n        .", " td {\n            border-top-width: 0;\n            border-bottom-width: 0;\n            padding-top: var(--ws-cart-table-row-padding-v);\n            padding-bottom: 0;\n        }\n\n        .", " td {\n            border-top-width: 0;\n            border-bottom-width: 0;\n        }\n\n        &:first-of-type .", ":first-of-type td {\n            border-top-width: 1px;\n        }\n\n        &:last-of-type .", ":last-of-type td { \n            padding-bottom: var(--ws-cart-table-row-padding-v);\n            border-bottom-width: 1px;\n        }\n    }\n\n    ",
    "\n"])), CART_REMOVE, CART_MODIFY, CART_PRICE, CART_TOTAL, CART_TABLE_ROW_UI, CART_ITEM, CART_TABLE_ROW_DESCRIPTION, CART_ITEM, CART_ITEM, function (_a) {
    var _b = _a.countOfSlots, countOfSlots = _b === void 0 ? 6 : _b;
    return "\n        --ws-slot-count-per-row: " + countOfSlots + ";\n    ";
});
export var IconOnCart = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    .", " & {\n        padding: var(--ws-cart-item-icon-padding, .5em) !important;\n        border: var(--ws-cart-item-icon-border, 1px solid #ccc) !important;\n        border-radius: var(--ws-cart-item-icon-border-radius, 4px) !important;\n    }\n\n    ", " {\n        height: 1em !important;\n        width: 1em !important;\n        outline: none !important;\n        display: block;\n    }\n"], ["\n    .", " & {\n        padding: var(--ws-cart-item-icon-padding, .5em) !important;\n        border: var(--ws-cart-item-icon-border, 1px solid #ccc) !important;\n        border-radius: var(--ws-cart-item-icon-border-radius, 4px) !important;\n    }\n\n    ", " {\n        height: 1em !important;\n        width: 1em !important;\n        outline: none !important;\n        display: block;\n    }\n"])), CART_TABLE_ROW_UI, SvgIcon);
var templateObject_1, templateObject_2;
